const dropBtn = document.querySelector(".dropbtn");

if (dropBtn) {
  dropBtn.addEventListener("click", function () {
    const dropdown = document.querySelector(".dropdown");
    if (dropdown) {
      dropdown.classList.toggle("show");
    }
  });

  
  function setDropdownHeight() {
    // Get the dropdown-content element
    const dropdownContent = document.querySelector(".dropdown-content");

    // Get all <a> elements within the dropdown-content
    const links = dropdownContent.querySelectorAll("a");

    // Calculate the total height of the first six links
    let totalHeight = 0;
    for (let i = 0; i < Math.min(6, links.length); i++) {
      totalHeight += links[i].offsetHeight;
    }
    totalHeight = totalHeight + 20;
    // Set the height of the dropdown-content
    dropdownContent.style.maxHeight = `${totalHeight}px`;
  }

  // Call the function when the page loads
  window.addEventListener("load", setDropdownHeight);

  // Optionally, call the function when the window is resized
  window.addEventListener("resize", setDropdownHeight);
}
